import type { IAudioService } from './IAudioService';
import type { IAnalyticsService } from './IAnalyticsService';
import type { IRemoteConfigService } from './IRemoteConfigService';
import type { IStorageService } from './IStorageService';
import type { IMessagingService } from './IMessagingService';
import type { IAuthService } from './IAuthService';
import type { IDataService } from './IDataService';
import type { IUserDataService } from './IUserDataService';
import type { IPurchaseService } from './IPurchaseService';
import type { IUserMapper } from './IUserMapper';
import type { IFunctionsService } from './IFunctionsService';
import type { ICrashlyticsService } from './ICrashlyticsService';

export interface ServiceContainer {
  crashlytics: ICrashlyticsService;
  functions: IFunctionsService;
  auth: IAuthService;
  userMapper: IUserMapper;
  data: IDataService;
  userData: IUserDataService;
  analytics: IAnalyticsService;
  storage: IStorageService;
  /**
   * Ephemeral per-tab storage. Web: window.sessionStorage. RN: an in-memory
   * Map (no equivalent native API; survives only within the process).
   */
  sessionStorage: IStorageService;
  remoteConfig: IRemoteConfigService;
  audio: IAudioService;
  messaging: IMessagingService;
  purchases: IPurchaseService;
}

let _container: ServiceContainer | null = null;

export function setServices(container: ServiceContainer): void {
  if (_container) {
    throw new Error('[services] already initialized');
  }
  _container = container;
}

export function getServices(): ServiceContainer {
  if (!_container) {
    throw new Error('[services] not initialized — call setServices() at app bootstrap');
  }
  return _container;
}

/** Test-only: reset the singleton between cases. Do NOT call from app code. */
export function _resetServicesForTesting(): void {
  _container = null;
}
